// extracted by mini-css-extract-plugin
export default {"modeButton":"ModeButton_modeButton__JAR-c","solo":"ModeButton_solo__2bG0Y","team":"ModeButton_team__gy8bP","icon":"ModeButton_icon__OQvVE","slideIn":"ModeButton_slideIn__Lp8zP"};